export const extractZipCodeFromString = (value: string) => value.match(/\d/g)?.join('') || '';
export const extractCityFromString = (value: string) =>
  value.replace(/[^a-zA-Z ÖöÄäËë-]+/g, '').trim();
